import { Collapse } from 'bootstrap'
import cleave from 'cleave.js'
import slideout from 'slideout'
import { tns } from 'tiny-slider/src/tiny-slider'

/**
 * Slideshow.
 * @see https://github.com/ganlanyuan/tiny-slider
 */
if (document.querySelector('.slideshow .slides')) {
  const slider = tns({
    container: '.slideshow .slides',
    items: 1,
    slideBy: 'page',
    autoplay: true,
    autoplayButtonOutput: false,
    controls: false,
    nav: false,
    responsive: {
      768: {
        nav: true,
      },
    },
  })
}

/**
 * Scroll to element.
 */
const scrollToElements = document.querySelectorAll('[data-scroll-to]')
for (const scrollToElement of scrollToElements) {
  scrollToElement.addEventListener('click', e => {
    e.preventDefault()

    const selector = e.target.dataset.scrollTo
    const offsetTop = document.querySelector(selector).offsetTop

    scroll({
      top: offsetTop,
      behavior: 'smooth',
    })
  })
}

/**
 * Slideout Nav.
 * @see https://github.com/mango/slideout
 */
const slideoutNav = new slideout({
  panel: document.getElementById('app-panel'),
  menu: document.getElementById('app-nav-mobile'),
  padding: 320,
  tolerance: 70,
  side: 'right',
  touch: false,
})

document.querySelector('.nav-icon').addEventListener('click', () => {
  slideoutNav.toggle()
})

document.querySelector('#app-nav-mobile .btn-close').addEventListener('click', () => {
  slideoutNav.close()
})

// Sub-menus
document.querySelectorAll('#app-nav-mobile .nav-link').forEach(link => {
  link.addEventListener('click', (e) => {
    if (e.target.getAttribute('href') == '#') {
      var btn = e.target.nextElementSibling
      var myCollapse = document.querySelector(btn.getAttribute('data-bs-target'))
      var bsCollapse = new Collapse(myCollapse, {
        toggle: true,
      })
    }
  })
})

/**
 * Mask phone inputs.
 */
Array.from(document.querySelectorAll('input[type="tel"]')).forEach(el => {
  new cleave(el, {
    numericOnly: true,
    blocks: [0, 3, 0, 3, 4],
    delimiters: ["(", ")", " ", "-"],
  })
})

/**
 * Mask numeric inputs.
 */
Array.from(document.querySelectorAll('input.numeric, input.currency, input.percentage')).forEach(el => {
  new cleave(el, {
    numeral: true,
    numeralThousandsGroupStyle: 'thousand',
    numeralDecimalScale: 2,
  })
})
